import React, { Component } from 'react'
import { Col, Row } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TitledLabel from '../../controls/TitledLabel'
import GenericModal from '../../widgets/common/GenericModal'
import { localize } from '../../util/Localizer'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import IconButton from '@material-ui/core/IconButton'
import ErrorMessage from '../common/ErrorMessage'
import Tooltip from '../../controls/Tooltip'
import Icon from '@material-ui/core/Icon'
import { Colors } from '../../theme'

class NewPractitioner extends Component {
  constructor () {
    super()
    this.state = { showGenericModal: false }
  }

  render () {
    const { classes = {} } = this.props
    const newPrac = this.props.newPrac
    // let p = this.props
    const elevation = this.props.isSelected === true ? 2 : 1
    const checked = this.props.isSelected && this.props.isSelected.registrationNumber === newPrac.registrationNumber

    const name = `${newPrac.firstName} ${newPrac.lastName}`

    return (
      <Paper className={classes.summaryCard} elevation={elevation}>
        {this.state.showGenericModal
          ? <Row>
            <Col xs={12}>
              <GenericModal
                ref={this.genericModal}
                showOk
                handleOk={() => {
                  this.props.delete()
                  this.setState({ showGenericModal: false })
                }}
                handleClose={() => {
                  this.setState({ showGenericModal: false })
                }}
                open={this.state.showGenericModal}
                OkButtonText={localize('yesText')}
                CancelButtonText={localize('noText')}
                modal
                message={localize('pages.SubmitAClaim.PractitionerDeleteWarning')}
              />
            </Col>
          </Row> : null}
        <Row start='xs'>
          <Col lg={1} xs={12} onClick={this.props.onClick} >
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked || false}
                  icon={<Icon style={{ color: Colors.Palette.primaryTextColor }}>person_outline</Icon>}
                  checkedIcon={<Icon color='primary'>person</Icon>}
                />
              }
            />
          </Col>
          <Col lg={9} xs={12}>
            <Row>
              <Col {...Columns.max4} onClick={this.props.onClick}>
                <TitledLabel title='common.name' value={name} />
              </Col>
              <Col {...Columns.max4} onClick={this.props.onClick} style={{ wordBreak: 'break-all' }}>
                <TitledLabel title='pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.registrationNumber' value={newPrac.registrationNumber} />
              </Col>

              <Col {...Columns.max4} onClick={this.props.onClick}>
                <TitledLabel title='pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.clinicName' value={newPrac.clinicName} />
              </Col>
              <Col {...Columns.max4} onClick={this.props.onClick}>
                <TitledLabel title='pages.SubmitAClaim.PhoneNumber' value={newPrac.phone} />
              </Col>
              <Col {...Columns.max4} onClick={this.props.onClick}>
                <TitledLabel title='pages.cardDetails.address' value={`${newPrac.addressLine1} - ${newPrac.postalCode}`} />
              </Col>
            </Row>
            {this.props.deleteError
              ? <Col xs={12}>
                <ErrorMessage error={this.props.deleteError} />
              </Col>
              : null}
          </Col>
          <Col lg={2} md={2} xs={12}>
            <Row around='xs' center='xs'>
              {this.props.canDelete &&
                <Col>
                  <Tooltip title={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.DeleteButton')} placement="bottom">
                    <IconButton
                      onClick={() => { this.setState({ showGenericModal: true }) }}
                      className='submitNavButton'
                    >
                      <Icon style={{ color: Colors.Palette.primaryTextColor }}>delete</Icon>
                    </IconButton>
                  </Tooltip>
                </Col>}
              {this.props.edit && <Col>
                <Tooltip title={localize('pages.SubmitAClaim.Expenses.EditButton')} placement="bottom">
                  <IconButton
                    onClick={this.props.edit}
                    className='submitNavButton'
                  >
                    <Icon style={{ color: Colors.Palette.primaryTextColor }}>edit</Icon>
                  </IconButton>
                </Tooltip>
              </Col>}
            </Row>
          </Col>
        </Row>

      </Paper>
    )
  }
}

const styles = {
  ...CardStyles
}

export default withStyles(styles)(NewPractitioner)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/newPractitioner.js